import React, { useState } from "react";
import { FiCheck, FiArrowLeft, FiSun, FiMoon, FiMonitor } from "react-icons/fi";

export default function ThemesView() {
  const [selectedTheme, setSelectedTheme] = useState("light");
  const [primaryColor, setPrimaryColor] = useState("#2563eb"); // Color navy por defecto

  const themes = [
    { id: "light", name: "Claro", icon: <FiSun />, description: "Tema claro con colores suaves" },
    { id: "dark", name: "Oscuro", icon: <FiMoon />, description: "Tema oscuro para reducir la fatiga visual" },
    { id: "system", name: "Sistema", icon: <FiMonitor />, description: "Utiliza el tema de tu sistema operativo" }
  ];

  const colorOptions = [
    { id: "navy", color: "#2563eb", name: "Azul Navy" },
    { id: "emerald", color: "#10b981", name: "Esmeralda" },
    { id: "violet", color: "#8b5cf6", name: "Violeta" },
    { id: "amber", color: "#f59e0b", name: "Ámbar" },
    { id: "rose", color: "#f43f5e", name: "Rosa" },
    { id: "gray", color: "#6b7280", name: "Gris" }
  ];

  const handleThemeChange = (themeId) => {
    setSelectedTheme(themeId);
    // Aquí se implementaría la lógica para cambiar el tema en la aplicación
  };

  const handleColorChange = (color) => {
    setPrimaryColor(color);
    // Aquí se implementaría la lógica para cambiar el color primario
  };

  return (
    <div className="bg-white rounded-lg shadow-md">
      <div className="p-6 border-b">
        <h1 className="text-2xl font-bold text-navy-900">Personalización de Temas</h1>
        <p className="text-gray-600 mt-2">
          Personaliza la apariencia de Lawfeed a tu gusto.
        </p>
      </div>

      <div className="p-6">
        <h2 className="text-lg font-semibold mb-4">Modo de Tema</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {themes.map((theme) => (
            <div
              key={theme.id}
              className={`border rounded-lg p-4 cursor-pointer transition-all ${
                selectedTheme === theme.id
                  ? "border-navy-600 bg-navy-50"
                  : "hover:border-navy-300"
              }`}
              onClick={() => handleThemeChange(theme.id)}
            >
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center">
                  <span className="mr-2 text-navy-600">{theme.icon}</span>
                  <span className="font-medium">{theme.name}</span>
                </div>
                {selectedTheme === theme.id && (
                  <FiCheck className="text-navy-600" />
                )}
              </div>
              <p className="text-sm text-gray-500">{theme.description}</p>
            </div>
          ))}
        </div>

        <h2 className="text-lg font-semibold mt-8 mb-4">Color Primario</h2>
        <div className="flex flex-wrap gap-3">
          {colorOptions.map((option) => (
            <button
              key={option.id}
              className={`w-8 h-8 rounded-full border-2 ${
                primaryColor === option.color
                  ? "border-gray-800"
                  : "border-transparent"
              }`}
              style={{ backgroundColor: option.color }}
              onClick={() => handleColorChange(option.color)}
              title={option.name}
            />
          ))}
        </div>

        <h2 className="text-lg font-semibold mt-8 mb-4">Vista Previa</h2>
        <div className={`border rounded-lg p-4 ${selectedTheme === 'dark' ? 'bg-gray-800 text-white' : 'bg-white'}`}>
          <div className="mb-4">
            <div className="h-6 w-24 rounded mb-2" style={{ backgroundColor: primaryColor }}></div>
            <div className="h-4 w-16 rounded mb-2" style={{ backgroundColor: primaryColor, opacity: 0.6 }}></div>
          </div>
          <div className="flex items-center mb-4">
            <div className="h-8 w-8 rounded-full mr-2" style={{ backgroundColor: primaryColor }}></div>
            <div>
              <div className="h-4 w-32 rounded mb-1 bg-gray-400"></div>
              <div className="h-3 w-24 rounded bg-gray-300"></div>
            </div>
          </div>
          <div className="flex justify-end">
            <button className="px-4 py-2 rounded text-white" style={{ backgroundColor: primaryColor }}>
              Botón de Acción
            </button>
          </div>
        </div>

        <div className="flex justify-end mt-6">
          <button className="px-4 py-2 bg-navy-600 text-white rounded-md hover:bg-navy-700">
            Guardar Cambios
          </button>
        </div>
      </div>
    </div>
  );
}